import React, { useContext } from "react";

import { observer } from "mobx-react";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import Markdown from "../../styles/Markdown";

const StyledWrapper = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? "transparent"};
  color: ${({ textColor }) => textColor ?? "#000"};
`;

function VenueDescription() {
  const { venuePageStore } = useStores();
  const { description } = venuePageStore.page.venue.profile;

  const { backgroundColor, componentClassName, wrapperClassName, textColor } =
    useContext(ComponentContext);

  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
      className={wrapperClassName}
      textColor={textColor}
    >
      <div className={componentClassName}>
        <Markdown>{description}</Markdown>
      </div>
    </StyledWrapper>
  );
}

export default observer(VenueDescription);
